import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.default,
    marginTop: 12,
    paddingTop: 8,
    paddingBottom: 8,
    borderRadius: 12
  }
}))

export default useStyles
